import {Language, MultilingualString} from "../redux/types";

export const multilingual = (language: Language | null | undefined, input: MultilingualString | null | undefined, defaultValue = '') => {
  if (!input || !language) return defaultValue
  if (language in input) return input[language]
  return defaultValue
}
